import Add from '@mui/icons-material/Add';
import RecordVoice from '@mui/icons-material/RecordVoiceOver';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import { blue, lightGreen, red, yellow } from '@mui/material/colors';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { MODO_PARTICIPACAO_ADVOGADO } from '@/dominio/ModoParticipacaoAdvogado';
import { SITUACAO_INSCRICAO_ADVOGADO } from '@/dominio/SituacaoInscricaoAdvogado';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Fragment } from 'react';
import Configuracao from '../../util/Configuracao';
import PopoverSecretaria from '../PopoverSecretaria';
import ReactComponent from '../ReactComponent';
import TableAdvogado from '../TableAdvogado';
import TextFieldSecretaria from '../TextFieldSecretaria';

class ParteAdvogados {
    constructor(codigoDaParte, denominacaoDaParte, nomeDaParte, advogados) {
        this.codigoDaParte = codigoDaParte;
        this.denominacaoDaParte = denominacaoDaParte;
        this.nomeDaParte = nomeDaParte;
        this.advogados = advogados;
    }
}

class SustentacaoOral extends ReactComponent {
    abrirPopover = false;
    acabouDeFechar = false;
    editarPedido = false;
    pedidosEsijOriginal =
        !this.origemProcessoPJe &&
        this.observableProps.registro?.pedidoSustentacaoOral?.pedidosDetalhados &&
        this.observableProps.registro.pedidoSustentacaoOral.pedidosDetalhados.length > 0
            ? JSON.parse(JSON.stringify(this.observableProps.registro.pedidoSustentacaoOral.pedidosDetalhados))
            : null;
    disabled = false;
    label = '';

    constructor(props) {
        super(props);

        makeObservable(this, {
            abrirPopover: observable,
            acabouDeFechar: observable,
            editarPedido: observable,
            pedidosEsijOriginal: observable,
            disabled: observable,
            label: observable,
            setLabel: action,
            registro: computed,
            todosOsPedidosDoProcesso: computed,
            sessao: computed,
            temPartipacaoSessao: computed,
            advogadosComParticipacaoSessao: computed,
            totalAdvogadosComParticipacaoSessao: computed,
            handleClose: action,
            handleAbrirPopover: action,
            editarPedidoSustentacaoOral: action,
            onChangeSustentacaoOral: action,
            adicionarAdvogado: action,
            atualizarListaPedidos: action,
            corConjuntoPresencasAdvogadosProcesso: computed,
            idIconeSustentacaoOral: computed,
            renderPopoverSecretaria: computed,
            renderPedidosSustentacaoOral: computed,
            renderPedidosSIJEdicao: computed
        });

        this.setLabel();
    }

    setLabel() {
        if (this.parametroStore.isOrgaoTST) {
            this.label = 'Inscrição para sessão de julgamento presencial (preferência/sustentação oral)';
        } else {
            this.label = 'Inscrição para sustentação oral presencial';
        }
    }

    get registro() {
        return this.observableProps.registro;
    }

    get todosOsPedidosDoProcesso() {
        if (
            !this.registro?.pedidoSustentacaoOral?.pedidosDetalhados ||
            this.registro.pedidoSustentacaoOral.pedidosDetalhados.length === 0
        ) {
            return null;
        }

        return this.registro.pedidoSustentacaoOral;
    }

    get sessao() {
        return this.sessaoStore.sessaoSelecionada;
    }

    get origemProcessoPJe() {
        return this.observableProps.registro.processo.origem === Configuracao.ORIGEM_PJE;
    }

    get temPartipacaoSessao() {
        return (
            this.registro &&
            this.registro.pedidoSustentacaoOral &&
            this.registro.pedidoSustentacaoOral.pedidosDetalhados &&
            this.registro.pedidoSustentacaoOral.pedidosDetalhados.some((pedido) => {
                return (
                    pedido.advogados &&
                    pedido.advogados.some((advogado) => {
                        return !!(
                            advogado.modoParticipacao &&
                            advogado.modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.PRESENCIAL.codigo
                        );
                    })
                );
            })
        );
    }

    get advogadosComParticipacaoSessao() {
        this.partesAdvogados = [];

        this.todosOsPedidosDoProcesso.pedidosDetalhados &&
            this.todosOsPedidosDoProcesso.pedidosDetalhados.forEach((pedido) => {
                let parteAdvogados = new ParteAdvogados();

                parteAdvogados.codigoDaParte = pedido.codigoDaParte;
                parteAdvogados.denominacaoDaParte = pedido.denominacaoDaParte;
                parteAdvogados.nomeDaParte = pedido.nomeDaParte;
                parteAdvogados.advogados = [];

                pedido.advogados &&
                    pedido.advogados.forEach((adv) => {
                        if (
                            adv.modoParticipacao &&
                            adv.modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.PRESENCIAL.codigo
                        ) {
                            parteAdvogados.advogados.push(adv);
                        }
                    });

                if (parteAdvogados.advogados.length > 0) {
                    // @ts-ignore
                    this.partesAdvogados.push(parteAdvogados);
                }
            });

        return this.partesAdvogados;
    }

    get totalAdvogadosComParticipacaoSessao() {
        let total = 0;

        this.advogadosComParticipacaoSessao.forEach((parteAdvogados) => {
            if (parteAdvogados.advogados) {
                total += parteAdvogados.advogados.length;
            }
        });

        return total;
    }

    handleClose = () => {
        this.acabouDeFechar = true;

        setTimeout(() => {
            runInAction(() => {
                this.acabouDeFechar = false;
            });
        }, 10);

        this.abrirPopover = false;
        this.editarPedido = false;
        this.disabled = false;
    };

    handleAbrirPopover = () => {
        if (!this.acabouDeFechar) {
            this.abrirPopover = true;
        }
    };

    editarPedidoSustentacaoOral = () => {
        this.editarPedido = true;
    };

    onChangeSustentacaoOral = (indexAdv, indexPedido, value) => {
        if (indexPedido !== null && indexAdv !== null) {
            this.todosOsPedidosDoProcesso.pedidosDetalhados[indexPedido].advogados[indexAdv].nome = value;
        } else {
            this.todosOsPedidosDoProcesso.descricaoAdvogado = value;
        }
    };

    adicionarAdvogado = (pedido) => {
        pedido.advogados.push({});
    };

    atualizarListaPedidos = () => {
        const todosOsPedidos = this.todosOsPedidosDoProcesso;

        if (todosOsPedidos) {
            this.pedidosEsijOriginal = JSON.parse(JSON.stringify(todosOsPedidos.pedidosDetalhados));
        } else {
            this.pedidosEsijOriginal = null;
        }
    };

    get corConjuntoPresencasAdvogadosProcesso() {
        let { totalAusentes, totalPresentes, totalNA } = this.contabilizarPresencas();

        if (totalPresentes > 0) {
            if (totalAusentes > 0) {
                return yellow[900];
            } else {
                return lightGreen[800];
            }
        } else {
            if (totalAusentes > 0) {
                return red[900];
            } else if (totalNA > 0) {
                return 'black';
            }
        }

        return 'gray';
    }

    contabilizarPresencas() {
        let totalPresentes = 0;
        let totalAusentes = 0;
        let totalNA = 0;

        if (
            this.todosOsPedidosDoProcesso &&
            this.todosOsPedidosDoProcesso.pedidosDetalhados &&
            this.todosOsPedidosDoProcesso.pedidosDetalhados.length !== 0
        ) {
            this.todosOsPedidosDoProcesso.pedidosDetalhados.forEach((pedido) => {
                pedido.advogados &&
                    pedido.advogados.forEach((adv) => {
                        if (adv.modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.PRESENCIAL.codigo) {
                            switch (adv.presente) {
                                case SITUACAO_INSCRICAO_ADVOGADO.PRESENTE.codigo:
                                    totalPresentes++;
                                    break;
                                case SITUACAO_INSCRICAO_ADVOGADO.AUSENTE.codigo:
                                    totalAusentes++;
                                    break;
                                case SITUACAO_INSCRICAO_ADVOGADO.INSCRITO.codigo:
                                    totalNA++;
                                    break;
                                default:
                                    break;
                            }
                        }
                    });
            });
        }

        return { totalAusentes, totalPresentes, totalNA };
    }

    async salvarAdvogadoSustentacaoOral(indexPedido, indexAdv, advogado) {
        let dto = {};
        dto.advogado = advogado;
        dto.codigoDaParte = this.pedidosEsijOriginal[indexPedido].codigoDaParte;
        dto.denominacaoDaParte = this.pedidosEsijOriginal[indexPedido].denominacaoDaParte;
        dto.nomeDaParte = this.pedidosEsijOriginal[indexPedido].nomeDaParte;

        if (!this.pedidosEsijOriginal[indexPedido].advogados[indexAdv]) {
            this.processoService
                .recuperarDetalhesProcessoSessao(this.registro.processo.numeroCompleto, this.registro.sessaoId)
                .then((processo) => {
                    processo.partesProcessuais.filter((parteProcessual) => {
                        if (
                            parteProcessual.partes[0].parte.nome === this.pedidosEsijOriginal[indexPedido].nomeDaParte
                        ) {
                            this.processoService.incluirAdvogadoSustentacaoOral(
                                this.registro.sessaoId,
                                this.registro.processo.numeroCompleto,
                                advogado,
                                parteProcessual.partes[0].parte.codigo
                            );
                        }
                        return null;
                    });
                });
        } else {
            await this.processoService.registrarPresencaAdvogadoProcesso(
                this.registro.sessaoId,
                this.registro.processo.numeroCompleto,
                dto
            );
        }
    }

    get idIconeSustentacaoOral() {
        return 'iconeSustentacaoOral' + this.registro.numeroProcesso + '-' + this.nextKey;
    }

    render() {
        if (!this.temPartipacaoSessao) {
            return null;
        }

        return (
            <Box
                onClick={this.handleAbrirPopover}
                style={{ cursor: 'pointer', display: 'flex', marginRight: '4px' }}
            >
                <Tooltip title={this.label}>
                    <RecordVoice
                        id={this.idIconeSustentacaoOral}
                        style={{ fill: this.corConjuntoPresencasAdvogadosProcesso, fillOpacity: '1' }}
                    />
                </Tooltip>
                {this.totalAdvogadosComParticipacaoSessao > 1 && (
                    <Add
                        id={'add' + this.registro.numeroProcesso}
                        style={{
                            fill: this.corConjuntoPresencasAdvogadosProcesso,
                            fillOpacity: '1',
                            width: '11px',
                            height: '11px'
                        }}
                    />
                )}
                {this.renderPopoverSecretaria}
            </Box>
        );
    }

    get renderPopoverSecretaria() {
        return (
            this.abrirPopover && (
                <PopoverSecretaria
                    open={this.abrirPopover}
                    onClose={this.handleClose}
                    placement="right"
                    anchorEl={() => document.getElementById(this.idIconeSustentacaoOral)}
                >
                    {!this.editarPedido ? (
                        <List style={{ maxWidth: '500px' }}>
                            <ListItem
                            //esta edicao gera inconsistência, pois não altera oab
                            //onClick={this.editarPedidoSustentacaoOral}
                            >
                                <span style={{ whiteSpace: 'pre-line' }}>{this.renderPedidosSustentacaoOral}</span>
                            </ListItem>
                        </List>
                    ) : (
                        <Fragment>
                            <div
                                style={{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                    marginLeft: '10px',
                                    overflowY: 'auto',
                                    minWidth: '30em',
                                    maxWidth: '500px'
                                }}
                            >
                                {this.origemProcessoPJe ? (
                                    <TextFieldSecretaria
                                        label={this.label}
                                        rows={'6'}
                                        value={this.todosOsPedidosDoProcesso.descricaoAdvogado}
                                        salvar={() =>
                                            this.processoService.editarNomeAdvogadoSustentacaoOral(
                                                this.registro.sessaoId,
                                                this.registro.processo.numeroCompleto,
                                                null,
                                                this.todosOsPedidosDoProcesso.descricaoAdvogado
                                            )
                                        }
                                        onChange={this.onChangeSustentacaoOral.bind(this, null, null)}
                                    />
                                ) : (
                                    this.renderPedidosSIJEdicao
                                )}
                            </div>
                            {!this.disabled && (
                                <span>
                                    <Button
                                        onClick={this.handleClose}
                                        color="secondary"
                                        disabled={this.disabled}
                                    >
                                        Fechar
                                    </Button>
                                </span>
                            )}
                        </Fragment>
                    )}
                </PopoverSecretaria>
            )
        );
    }

    /**
     * Chave para identificar o registro do advogado unicamente.
     * @todo [TODO] Unificar esse método em uma classe de negócio (pois está replicado em outros classes)
     * @param {object} adv Advogado
     * @returns {string} Chave única para o advogado.
     */
    getRepresentanteKey(adv) {
        if (adv && adv.nome && adv.regOAB && adv.regOAB.numero && adv.regOAB.siglaUf) {
            if (adv.regOAB.letra) {
                return `${adv.nome}|${adv.regOAB.numero}-${adv.regOAB.letra}-${adv.regOAB.siglaUf}`;
            } else {
                return `${adv.nome}|${adv.regOAB.numero}-${adv.regOAB.siglaUf}`;
            }
        }

        return '';
    }

    get renderPedidosSustentacaoOral() {
        return this.todosOsPedidosDoProcesso.pedidosDetalhados !== undefined && this.temPartipacaoSessao ? (
            this.advogadosComParticipacaoSessao.map((pedido, indexPedido) => {
                return (
                    <div
                        key={'pedido' + indexPedido}
                        style={{
                            marginBottom:
                                this.todosOsPedidosDoProcesso.pedidosDetalhados.length - 1 !== indexPedido ? '10px' : 0
                        }}
                    >
                        <span style={{ color: blue[900], fontWeight: 'bold' }}>
                            {pedido.denominacaoDaParte
                                ? pedido.denominacaoDaParte + ': '
                                : '(Denominação não informada) '}{' '}
                            {pedido.nomeDaParte}
                        </span>
                        {pedido.advogados.map((advogado) => {
                            let advKey = this.getRepresentanteKey(advogado);

                            if (!advKey) {
                                advKey = String(this.nextKey);
                            }

                            return (
                                <TableAdvogado
                                    advogado={advogado}
                                    key={advKey}
                                />
                            );
                        })}
                    </div>
                );
            })
        ) : (
            <div>{this.todosOsPedidosDoProcesso.descricaoAdvogado}</div>
        );
    }

    get renderPedidosSIJEdicao() {
        return (
            <div style={{ marginBottom: '15px', maxHeight: '350px' }}>
                {this.todosOsPedidosDoProcesso &&
                    this.todosOsPedidosDoProcesso.pedidosDetalhados.map((pedido, indexPedido) => {
                        return (
                            <div
                                key={'pedido' + indexPedido}
                                style={{
                                    marginBottom:
                                        this.todosOsPedidosDoProcesso.pedidosDetalhados.length - 1 !== indexPedido
                                            ? '20px'
                                            : 0
                                }}
                            >
                                <Typography style={{ color: blue[900], fontWeight: 'bold' }}>
                                    {pedido.denominacaoDaParte
                                        ? pedido.denominacaoDaParte + ': '
                                        : '(Denominação não informada) '}
                                    {pedido.nomeDaParte}
                                </Typography>
                                {pedido.advogados.map((advogado, indexAdv) => {
                                    return (
                                        <div
                                            key={'adv' + indexAdv}
                                            style={{ display: 'flex', alignItems: 'center', marginBottom: '2px' }}
                                        >
                                            Advogado:
                                            <TextFieldSecretaria
                                                label="Inscrições para sustentações orais"
                                                rows={'1'}
                                                value={advogado.nome}
                                                id={'advogado' + indexAdv}
                                                salvar={() =>
                                                    this.salvarAdvogadoSustentacaoOral(indexPedido, indexAdv, advogado)
                                                }
                                                onChange={this.onChangeSustentacaoOral.bind(
                                                    this,
                                                    indexAdv,
                                                    indexPedido
                                                )}
                                                tempoTimeout={200}
                                                callbackSalvar={this.atualizarListaPedidos}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}
            </div>
        );
    }
}

export default inject('stores')(observer(SustentacaoOral));
